import {EditorState, Transaction} from "prosemirror-state";
import {EditorView} from "prosemirror-view";

import {TriggerActionCommandAdditionalParams} from "./types";

import {insertNode} from "./utils";


import {schema} from "../../config/schema";


export const insertBlockquote = (state: EditorState, dispatch?: (tr: Transaction) => void, view?: EditorView, additionalParams?: TriggerActionCommandAdditionalParams) => {
    const quoteNode = schema.nodes.blockquote.createAndFill()!;
    return insertNode(quoteNode, state, dispatch, view, additionalParams);
}
